import React from "react"
import useAuth from "auth/useAuth"
import useRescuers from "hooks/useRescuers"
// import HomeDashboard from "./HomeDashboard"  // "Pregled" section, temporarily hidden
import HomeRescues from "./HomeRescues"
import ShiftRescueStats from "./ShiftRescueStats"
import PendingUploads from "./PendingUploads"
import Wiki from "components/wiki/Wiki"
import "./HomePage.css"


export default function HomePage() {

    const {admin} = useAuth()
    const {data} = useRescuers()

    return <div id="home" data-rescuers={data?.length}>
        {/* <HomeDashboard/> */}
        <div className="columns">
            {/* <Wiki page="home" className="white shadow"/> */}
            <HomeRescues/>
            <ShiftRescueStats/>
        </div>
        {admin && <PendingUploads/>}
    </div>
}